import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";

const name = "getGeneralFeedbacks";
const initialState = createInitialState();

function createInitialState() {
  return {
    done: false,
    error: false,
    spinner: false,
    getGeneralFeedbacks: null,
  };
}

export const getGeneralFeedbacks = createAsyncThunk(
  "getGeneralFeedbacks",
  async (rejectWithValue) => {
    try {
      const response = await api.get(`/super/api/feedback/get/generals`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const getGeneralFeedbacksSlice = createSlice({
  name: name,
  initialState,
  reducers: {
    resetGetGeneralFeedbacks: (state) => {
      state.done = false;
      state.error = false;
      state.spinner = false;
      state.getGeneralFeedbacks = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getGeneralFeedbacks.pending, (state) => {
        state.spinner = true;
        state.error = false;
      })
      .addCase(getGeneralFeedbacks.fulfilled, (state, action) => {
        state.done = true;
        state.spinner = false;
        state.error = false;
        state.getGeneralFeedbacks = action.payload;
      })
      .addCase(getGeneralFeedbacks.rejected, (state, action) => {
        state.done = false;
        state.spinner = false;
        state.error = action.payload;
      });
  },
});

export const { resetGetGeneralFeedbacks } = getGeneralFeedbacksSlice.actions;
export const getGeneralFeedbacksReducer = getGeneralFeedbacksSlice.reducer;
